import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import mom from "../../assets/Department/MOM.jpeg";
import AcadCalendar from "../../Components/Academics/AcadCalender"
import SidebarGalleryPage from "../../Components/Main/Sidebargallery"
import { toast } from "react-toastify";
import NewsFeed from "../Home/News";
import LaboratoryDetails from "../LaboratoryDetails/laboratoryDetails";
import DeptNewsLetter from "../DeptNewsLetter/NewsLetter";


const Deptmom = () => {

  // Faculty data

  const [staff, setStaff] = useState([]);

  // Fetch staff data from API
  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/staff`);
        setStaff(response.data.staff);
        // console.log("Dharma",response);
      } catch (error) {
        console.error("Error fetching staff:", error);
        toast.error("Failed to fetch staff data.");
      }
    };
    

    fetchStaff();

    
  }, []);

  const containers = [
    {
      title: "Introduction",
      content: (
        <>
          <p className="p-2">
            The students undergoing the diploma course in Modern Office practice
            , as they acquire both theoretical and practical knowledge on
            various commercial areas like Financial, Business Accounting, Income
            Tax, Auditing, Statistics, Cost Accounting, Stenography, Hindi
            English typing, Word processing and spreadsheet, Desktop publishing,
            Entrepreneurship Development etc.
          </p>
        </>
      ),
    },
    {
      title: "Programme Educational Objectives",
      content: (
        <div className="p-2">
          <p className="mb-4">
            The programme is designed after comprehensive discussions and
            analytical deliberation from experts of the subject working in
            Polytechnic and from industries.
          </p>
          <ul className="pl-5 mb-4 list-disc">
            <li>To make competent and capable Office Assistant & Manager</li>
            <li>To make efficient P.A.</li>
            <li>To make efficient Typist and Stenographer.</li>
            <li>To make Educated Citizens.</li>
            <li>To make good leaders & team member.</li>
          </ul>
        </div>
      ),
    },
    {
      title: "Programme Outcomes",
      content: (
        <div className="p-2">
          <p className="mb-4">
            The three-year diploma holders of Modern Office management can avail
            themselves of the following job opportunities
          </p>
          <ul className="ml-6 mb-4 list-disc">
            <li>
              Jr. Executive in various Public/Private sectors/Undertaking.
            </li>
            <li>Steno Typist in various Public/Private sectors/Undertaking.</li>
            <li>Typist in various Public/Private sectors/Undertaking.</li>
            <li>
              Stenographer in various Government/Public/Private sector
              organizations.
            </li>
            <li>Junior Executive in Management Information System (MIS).</li>
            <li>
              Personal Assistant/Personal Secretary/Secretary to Executive.
            </li>
            <li>
              Office Assistant/Clerks in various organizations like Banks/Public
              Sector Organizations/Govt. Departments.
            </li>
            <li>
              Computer Operators including word processor/data entry
              operator/Assistant Programmer Statistical investigators.
            </li>
            <li>
              Receptionists, Telephone/Telex Operators in various concerns.
            </li>
            <li>Accounts & Audit assistants in various organizations.</li>
            <li>
              Lab Technician-cum-Demonstrators in office equipment Lab and
              Computer Lab.
            </li>
            <li>Self Employment:</li>
            <ul className="pl-5 mb-4 list-decimal">
              <li>May engage in Typing work independently.</li>
              <li>May open Business Computer Centre.</li>
            </ul>
          </ul>
        </div>
      ),
    },
    {
      title: "Programme Specific Outcomes",
      content: (
        <ol class="list-decimal ml-6 text-gray-700">
          <li>Perform his duties successfully as an Office Employee.</li>
          <li>Perform his duties successfully as a Personal Secretary.</li>
          <li>Perform his duties as Accountants earnestly and as per rules.</li>
        </ol>
      ),
    },
    // {
    //   title: "Faculty",
    //   content: (
    //     <div className="min-h-screen py-8">
    //       <h1 className="mb-6 text-2xl font-bold text-center">Faculty List</h1>
    //       <div className="max-w-4xl p-6 mx-auto bg-white shadow-md">
    //         {/* Filter staff based on department 'CSE' */}
    //         {staff
    //           .filter((staffMember) => staffMember.department === "MOM")
    //           .map((staffMember, index) => (
    //             <div
    //               key={staffMember.id}
    //               className="mb-6 p-4 border-b border-gray-200 hover:bg-teal-50 transition duration-200 ease-in-out"
    //             >
    //               <span className="block text-lg font-semibold text-gray-800">
    //                 {index + 1}. {staffMember.name || "-"}
    //               </span>
    //               <div className="flex items-center space-x-4 mt-2">
    //                 <img
    //                   src={staffMember.profilePhoto ? `/api/uploads/staffimages/${staffMember.profilePhoto}` : "/default-profile.jpg"}
    //                   alt={staffMember.name}
    //                   className="w-15 h-15 sm:w-12 sm:h-12 rounded-full shadow-md"
    //                 />
    //                 <div className="text-gray-700">
    //                   <p>
    //                     <strong>Qualification:</strong>{" "}
    //                     {staffMember.Qualification || "-"}
    //                   </p>
    //                   <p>
    //                     <strong>Department:</strong>{" "}
    //                     {staffMember.department || "-"}
    //                   </p>
    //                   <p>
    //                     <strong>Specialization:</strong>{" "}
    //                     {staffMember.Specialization || "-"}
    //                   </p>
    //                   <p>
    //                     <strong>Experience:</strong>{" "}
    //                     {staffMember.Experience || "-"}
    //                   </p>
    //                 </div>
    //               </div>
    //             </div>
    //           ))}
    //         {/* Display a message if no MOM faculty is found */}
    //         {staff.filter((staffMember) => staffMember.department === "MOM").length ===
    //           0 && (
    //             <p className="text-center text-gray-500">No MOM faculty found.</p>
    //           )}
    //       </div>
    //     </div>
    //   ),
    // },

    {
      title: "Faculty",
      content: (
        <div className="min-h-screen py-8 bg-gray-100">
          <h1 className="mb-6 text-2xl font-bold text-center text-gray-800">
            Faculty List
          </h1>
          <div className="max-w-5xl p-6 mx-auto bg-white rounded-lg shadow-lg">
            {/* Filter staff based on department 'MOM' */}
            {staff
              .filter((staffMember) => staffMember.department === "MOM")
              .map((staffMember, index) => (
                <div
                  key={staffMember.id}
                  className="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-6 mb-6 p-4 border-b border-gray-200 hover:bg-teal-50 transition duration-200 ease-in-out"
                >
                  {/* Profile Image */}
                  <img
                    src={
                      staffMember.profilePhoto
                        ? `/api/uploads/staffimages/${staffMember.profilePhoto}`
                        : "/default-profile.jpg"
                    }
                    alt={staffMember.name}
                    className="w-20 h-20 sm:w-24 sm:h-24 rounded-full shadow-md"
                  />
                  {/* Staff Information */}
                  <div className="flex-1 text-gray-800">
                    <p className="text-lg font-semibold">
                      {index + 1}. {staffMember.name || "-"}
                    </p>
                    <p className="text-sm mt-1">
                      <strong>Qualification:</strong>{" "}
                      {staffMember.Qualification || "-"}
                    </p>
                    <p className="text-sm mt-1">
                      <strong>Department:</strong>{" "}
                      {staffMember.department || "-"}
                    </p>
                    <p className="text-sm mt-1">
                      <strong>Specialization:</strong>{" "}
                      {staffMember.Specialization || "-"}
                    </p>
                    <p className="text-sm mt-1">
                      <strong>Experience:</strong>{" "}
                      {staffMember.Experience || "-"}
                    </p>
                  </div>
                </div>
              ))}
            {/* Display a message if no MOM faculty is found */}
            {staff.filter((staffMember) => staffMember.department === "MOM")
              .length === 0 && (
              <p className="text-center text-gray-500">No MOM faculty found.</p>
            )}
          </div>
             
        </div>
      ),
    },

    {
      title: "Admission Criteria",
      content: (
        <div className="w-2/3 p-6">
          <p className="mb-4">It is a full-time regular programme.</p>
          <p className="mb-4">
            Duration of the programme is Three years (six semesters).
          </p>
          <p className="mb-4">Intake capacity is 60 seats.</p>
          <p className="mb-4">Candidate should be M.P. domicile.</p>
          <p className="mb-4">Eligibility is (10+2) pass-out</p>
          <p className="mb-4">
            Entry through Pre Polytechnic Test (PPT) conducted by PEB, Bhopal
            <a
              href="http://www.peb.mp.gov.in"
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal-500 underline"
            >
              {" "}
              (www.peb.mp.gov.in)
            </a>
            and on qualifying exam (12th) basis.
          </p>
          <p className="mb-4">
            Admission through Centralized Online Counseling organized by DTEMP /
            at College Level.
          </p>
          <p className="mb-4">Reservation of seats as per M.P. Govt. Rules.</p>
        </div>
      ),
    },
    {
      title: "Academic Calendar",
      content: (
        <div className="hover:cursor-pointer ml-4">
          {/* <a href={<AcadCalendar />}>
            Click Here for Academic Calendar</a> */}
          <a href="https://www.rgpvdiploma.in/Academics/Acadmic_calander.aspx">
            Click Here for Academic Calendar
          </a>
        </div>
      ),
    },
    {
      title: "Schemes/Syllabus",
      content: (
        <div className="hover:cursor-pointer ml-4">
          <a href="/department/mom/syllabus">Click Here</a>
        </div>
      ),
    },
    {
      title: "Learning Resources",
      content: (
        <div className="p-6 ">
          <h1 className="text-xl font-bold text-white bg-teal-500 p-2 rounded-sm mb-4">
            E-Learning
          </h1>
          <ul class="mb-4 list-disc pl-5 ">
            <li>
              <a
                href="https://tallysolutions.com/download/"
                target="_blank"
                class="hover:text-blue-500"
              >
                TALLY
              </a>
            </li>
            <li>
              <a
                href="https://adobe-pagemaker.en.softonic.com/"
                target="_blank"
                class="hover:text-blue-500"
              >
                PAGEMAKER
              </a>
            </li>
            <li>
              <a
                href="https://www.mpgkpdf.com/p/mp-gk-in-hindi.html"
                target="_blank"
                class="hover:text-blue-500"
              >
                MP GK
              </a>
            </li>
            <li>
              <a
                href="https://selfservice.gstsystem.in/"
                target="_blank"
                class="hover:text-blue-500"
              >
                GST PORTAL
              </a>
            </li>
            <li>
              <a
                href="https://eportal.incometax.gov.in/"
                target="_blank"
                class="hover:text-blue-500"
              >
                INCOME TAX PORTAL
              </a>
            </li>
            <li>
              <a
                href="http://www.mpwrd.gov.in/download_hindi_fonts"
                target="_blank"
                class="hover:text-blue-500"
              >
                HINDI FONT
              </a>
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Laboratory Details",
      content: (
        <div className="ml-4">
          <LaboratoryDetails />
        </div>
      ),
    },
    {
      title: "Department Newsletter",
      content: (
        <div className="ml-4">
          {/* <a href="">Click Here for Department Newsletter</a> */}
          <DeptNewsLetter />
        </div>
      ),
    },
    {
      title: "Past Workshops/Expert Lectures/Educational Visits/Tours",
      content: (
        <div className="ml-4">
          <a href="">Click Here for Details</a>
        </div>
      ),
    },
    {
      title: "Contact Us",
      content: (
        <div className="ml-4">
          <p>Modern Office Management</p>
          <p>Head of Department – Dr. Pankaj Jain</p>
          <p>Mobile – 9827046409</p>
        </div>
      ),
    },
    // Add other sections here
  ];

  const ContainerItem = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef(null);

    const toggleContainer = () => {
      setIsOpen(!isOpen);
    };

    return (
      <div className="my-4 border-4 border-teal-500 shadow-md mb-6 rounded-lg">
        <div
          className="flex items-center justify-between p-2 text-xl font-bold text-white bg-teal-500 cursor-pointer"
          onClick={toggleContainer}
        >
          <h2>{title}</h2>
          <span
            className={`transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""
              }`}
          >
            &#9660;
          </span>
        </div>
        <div
          ref={contentRef}
          style={{
            maxHeight: isOpen ? `${contentRef.current.scrollHeight}px` : "0px",
            opacity: isOpen ? "1" : "0",
            transform: isOpen ? "scaleY(1)" : "scaleY(0.9)",
            transition: "all 0.5s ease-in-out",
          }}
          className="overflow-hidden transition-all duration-500 ease-in-out origin-top transform"
        >
          <div className="p-2 text-gray-800 bg-white">{children}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-gray-100 min-h-screen p-2">
      <div className="flex flex-wrap lg:flex-nowrap p-10 gap-8 ">
        <div className="">
          <div>
            <img
              src={mom}
              alt="MOM"
              className="w-full shadow-md p-2 border-4 border-teal-500 rounded-lg mb-8"
            />
          </div>
          <div className="border-4 border-teal-500 rounded-lg p-2">
            <h1 className="text-white bg-teal-500 text-xl p-2 font-bold rounded-sm">
              Vision
            </h1>
            <div className="mt-2 p-2 text-gray-800">
              <p className="">
                A diploma holder of Modern Office Management will contribute
                effectively with his Managerial skill in accordance to the needs
                of Good Governance in Modern Office.
              </p>
            </div>
          </div>
          <div className="border-4 border-teal-500 rounded-lg p-2 mt-8">
            <h1 className="text-white bg-teal-500 text-xl p-2 font-bold rounded-sm">
              Mission
            </h1>
            <div className="mt-2 p-2 text-gray-800">
              <p className="">
                To offer a high-quality diploma program through an updated
                curriculum aligned with current industry requirements, aimed at
                enhancing and developing professional and technical competencies
                in the field of Modern Office Management.
              </p>
            </div>
            <ul className="list-disc px-8">
              <li>Continuous Upgradation/Modification of Syllabus.</li>
              <li>
                Prepare diplomaholder as administrative executive / Manager /
                Entrepreneur.
              </li>
              <li>Prepare diploma holder for effective leadership.</li>
              {/* <li>
                To inculcate social values and professional ethics for the
                overall development of the community.
              </li> */}
            </ul>
          </div>
          <div className="mt-8">
            {/* Loop through the containers */}
            {containers.map((container, index) => (
              <ContainerItem key={index} title={container.title}>
                {container.content}
              </ContainerItem>
            ))}
          </div>
        </div>
        {/* Right Section: Gallery */}
        <div className="w-full lg:w1/3">
          <SidebarGalleryPage />
        </div>
      </div>
    </div>
  );
}

export default Deptmom;
